// extracted by mini-css-extract-plugin
module.exports = {"container":"SummaryItem_container__1YmRB","icon":"SummaryItem_icon__1eWGO","title":"SummaryItem_title__p4QDh","body":"SummaryItem_body__3TlRd"};